/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Card 2: Integrated Insights.
 *
 * AI-generated per Steve's Prompt 3 (IPSAT_AI_Prompt_Framework.md).
 * Until Phase C lands, `aiContent.integrated_insights` will be empty on
 * saved reports and we show a "generating" placeholder. The Anthropic
 * call writes 4–6 short insights with title + body to that field at
 * /purchase time.
 */
interface IntegratedInsight { title: string; body: string; }

@Component({
  selector: 'app-integrated-insights-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './integrated-insights-modal.component.html',
})
export class IntegratedInsightsModalComponent {
  @Input() insights: IntegratedInsight[] = [];

  constructor(public bsModalRef: BsModalRef) {}

  close(): void {
    this.bsModalRef.hide();
  }
}
